if (!customElements.get('notesos-password-input')) {
  customElements.define(
    'notesos-password-input',
    class NotesOSPasswordInput extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.input = this.querySelector('[data-notesos-password-field]');
        this.error = this.querySelector('[data-notesos-password-error]');
        this.toggle = this.querySelector('[data-notesos-password-toggle]');
        this.icon = this.querySelector('[data-notesos-password-icon]');

        this.toggle?.addEventListener('click', () => this.toggleVisibility());
        this.input?.addEventListener('input', () => this.hideError());
        this.input?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          this.validate();
        });
      }

      toggleVisibility() {
        if (!this.input || !this.toggle) return;

        const willShow = this.input.type === 'password';
        this.input.type = willShow ? 'text' : 'password';
        this.toggle.setAttribute('aria-pressed', String(willShow));
        this.toggle.setAttribute('aria-label', willShow ? 'Hide password' : 'Show password');
        this.toggle.setAttribute('title', willShow ? 'Hide password' : 'Show password');
        if (this.icon) this.icon.textContent = willShow ? '🙉' : '🙈';
        this.input.focus({ preventScroll: true });
      }

      validate() {
        if (!this.input) return false;

        const entered = this.input.value.trim().toLocaleLowerCase();
        const expected = (this.dataset.password || '').trim().toLocaleLowerCase();
        const isValid = entered !== '' && expected !== '' && entered === expected;

        if (!isValid) {
          this.showError();
          this.input.setAttribute('aria-invalid', 'true');
          this.input.focus({ preventScroll: true });
          return false;
        }

        this.hideError();
        this.input.removeAttribute('aria-invalid');
        this.dispatchEvent(new CustomEvent('notesos:password-success', { bubbles: true }));

        const redirectUrl = this.dataset.redirectUrl || '';
        if (redirectUrl) window.location.assign(redirectUrl);
        return true;
      }

      showError() {
        if (this.error) this.error.hidden = false;
      }

      hideError() {
        if (this.error) this.error.hidden = true;
        this.input?.removeAttribute('aria-invalid');
      }
    }
  );
}

if (!window.NotesOSPasswordEventsBound) {
  window.NotesOSPasswordEventsBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-notesos-password-submit]');
    if (!trigger) return;

    event.preventDefault();
    const scope = trigger.closest('.notesos-password-section') || document;
    scope.querySelector('notesos-password-input')?.validate();
  });
}
